import React, { useEffect, useState } from "react"
import {
    Row,
    Col,
    Card,
    CardBody,
    Button,
    Table,
    Badge,
    Modal,
    ModalHeader,
    ModalBody,
    Form,
    FormGroup,
    Label,
    Input,
} from "reactstrap"
import { setBreadcrumbItems } from "../../../store/actions"
import { connect } from "react-redux"
import moment from "moment"
import { getPendingSubscriptions, getSubscriptionStats, validateSubscriptionPayment } from "../../../helpers/fakebackend_helper"
import { toast } from "react-toastify"

const PendingSubscriptions = (props) => {
    document.title = "Abonnements en Attente | CRM Admin"

    const [subscriptions, setSubscriptions] = useState([])
    const [stats, setStats] = useState({})
    const [modal, setModal] = useState(false)
    const [currentSub, setCurrentSub] = useState(null)
    const [loading, setLoading] = useState(false)
    const [formData, setFormData] = useState({
        payment_method: '',
        payment_reference: '',
        payment_notes: ''
    })

    const breadcrumbItems = [
        { title: "Admin", link: "#" },
        { title: "Abonnements en Attente", link: "#" },
    ]

    useEffect(() => {
        props.setBreadcrumbItems("Abonnements en Attente", breadcrumbItems)
        loadData()
    }, [])

    const loadData = async () => {
        try {
            const [subs, statsData] = await Promise.all([
                getPendingSubscriptions(),
                getSubscriptionStats()
            ])
            setSubscriptions(subs)
            setStats(statsData)
        } catch (error) {
            console.error("Error loading data:", error)
        }
    }

    const handleValidate = (subscription) => {
        setCurrentSub(subscription)
        setFormData({
            payment_method: '',
            payment_reference: '',
            payment_notes: ''
        })
        setModal(true)
    }

    const toggle = () => {
        setModal(!modal)
        if (modal) {
            setCurrentSub(null)
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault()

        if (!formData.payment_method || !formData.payment_reference) {
            toast.error("Veuillez remplir tous les champs obligatoires")
            return
        }

        setLoading(true)
        try {
            await validateSubscriptionPayment(currentSub.id, formData)
            toast.success("Abonnement activé avec succès !")
            toggle()
            loadData()
        } catch (error) {
            toast.error("Erreur lors de l'activation")
            console.error(error)
        } finally {
            setLoading(false)
        }
    }

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        })
    }

    const getStatusBadge = (status) => {
        switch (status) {
            case 'pending_payment': return <Badge color="warning">En Attente</Badge>
            case 'active': return <Badge color="success">Actif</Badge>
            case 'expired': return <Badge color="danger">Expiré</Badge>
            default: return status
        }
    }

    const getPaymentMethodLabel = (method) => {
        const methods = {
            'bank_transfer': 'Virement Bancaire',
            'cash': 'Espèces',
            'check': 'Chèque',
            'mobile_money': 'Mobile Money',
            'other': 'Autre'
        }
        return methods[method] || method
    }

    return (
        <React.Fragment>
            <div className="container-fluid">
                {/* Stats Cards */}
                <Row>
                    <Col md="3">
                        <Card className="mini-stats-wid">
                            <CardBody>
                                <div className="d-flex">
                                    <div className="flex-grow-1">
                                        <p className="text-muted fw-medium">En Attente</p>
                                        <h4 className="mb-0">{stats.pending_count || 0}</h4>
                                    </div>
                                    <div className="avatar-sm rounded-circle bg-warning align-self-center border-0 shadow-none">
                                        <span className="avatar-title rounded-circle bg-warning border-0 shadow-none">
                                            <i className="mdi mdi-clock-outline font-size-24"></i>
                                        </span>
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                    <Col md="3">
                        <Card className="mini-stats-wid">
                            <CardBody>
                                <div className="d-flex">
                                    <div className="flex-grow-1">
                                        <p className="text-muted fw-medium">Actifs</p>
                                        <h4 className="mb-0">{stats.active_count || 0}</h4>
                                    </div>
                                    <div className="avatar-sm rounded-circle bg-success align-self-center border-0 shadow-none">
                                        <span className="avatar-title rounded-circle bg-success border-0 shadow-none">
                                            <i className="mdi mdi-check-circle-outline font-size-24"></i>
                                        </span>
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                    <Col md="3">
                        <Card className="mini-stats-wid">
                            <CardBody>
                                <div className="d-flex">
                                    <div className="flex-grow-1">
                                        <p className="text-muted fw-medium">Expirés</p>
                                        <h4 className="mb-0">{stats.expired_count || 0}</h4>
                                    </div>
                                    <div className="avatar-sm rounded-circle bg-danger align-self-center border-0 shadow-none">
                                        <span className="avatar-title rounded-circle bg-danger border-0 shadow-none">
                                            <i className="mdi mdi-alert-circle-outline font-size-24"></i>
                                        </span>
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                    <Col md="3">
                        <Card className="mini-stats-wid">
                            <CardBody>
                                <div className="d-flex">
                                    <div className="flex-grow-1">
                                        <p className="text-muted fw-medium">Revenus ce Mois</p>
                                        <h4 className="mb-0">{stats.total_revenue_month || 0} MAD</h4>
                                    </div>
                                    <div className="avatar-sm rounded-circle bg-primary align-self-center border-0 shadow-none">
                                        <span className="avatar-title rounded-circle bg-primary border-0 shadow-none">
                                            <i className="mdi mdi-cash-multiple font-size-24"></i>
                                        </span>
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

                {/* Pending Subscriptions Table */}
                <Row>
                    <Col lg="12">
                        <Card>
                            <CardBody>
                                <div className="d-flex align-items-center mb-4">
                                    <div className="flex-grow-1">
                                        <h4 className="card-title">Abonnements en Attente de Paiement</h4>
                                        <p className="text-muted">Validez les paiements reçus pour activer les abonnements</p>
                                    </div>
                                </div>

                                <div className="table-responsive">
                                    <Table className="table-centered table-nowrap mb-0">
                                        <thead className="table-light">
                                            <tr>
                                                <th>Entreprise</th>
                                                <th>Plan</th>
                                                <th>Montant</th>
                                                <th>Date Demande</th>
                                                <th>Statut</th>
                                                <th>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {subscriptions.map((sub, key) => (
                                                <tr key={key}>
                                                    <td>
                                                        <h5 className="font-size-14 mb-1">{sub.company?.name}</h5>
                                                        <p className="text-muted mb-0">{sub.company?.email}</p>
                                                    </td>
                                                    <td>{sub.plan?.name}</td>
                                                    <td className="fw-bold">{sub.plan?.price} MAD</td>
                                                    <td>{moment(sub.created_at).format("DD/MM/YYYY")}</td>
                                                    <td>{getStatusBadge(sub.status)}</td>
                                                    <td>
                                                        <Button
                                                            color="success"
                                                            size="sm"
                                                            onClick={() => handleValidate(sub)}
                                                        >
                                                            <i className="mdi mdi-check me-1"></i>
                                                            Valider Paiement
                                                        </Button>
                                                    </td>
                                                </tr>
                                            ))}
                                            {subscriptions.length === 0 && (
                                                <tr>
                                                    <td colSpan="6" className="text-center py-4">
                                                        <i className="mdi mdi-check-circle text-success font-size-48 d-block mb-2"></i>
                                                        <p className="mb-0">Aucun abonnement en attente</p>
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </Table>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

                {/* Validation Modal */}
                <Modal isOpen={modal} toggle={toggle} size="lg">
                    <ModalHeader toggle={toggle}>
                        Valider le Paiement
                    </ModalHeader>
                    <ModalBody>
                        {currentSub && (
                            <>
                                <div className="alert alert-info">
                                    <h5 className="alert-heading">Détails de l'Abonnement</h5>
                                    <p className="mb-1"><strong>Entreprise :</strong> {currentSub.company?.name}</p>
                                    <p className="mb-1"><strong>Plan :</strong> {currentSub.plan?.name}</p>
                                    <p className="mb-0"><strong>Montant :</strong> {currentSub.plan?.price} MAD</p>
                                </div>

                                <Form onSubmit={handleSubmit}>
                                    <Row>
                                        <Col lg="6">
                                            <FormGroup>
                                                <Label>Mode de Paiement Reçu <span className="text-danger">*</span></Label>
                                                <Input
                                                    type="select"
                                                    name="payment_method"
                                                    value={formData.payment_method}
                                                    onChange={handleChange}
                                                    required
                                                >
                                                    <option value="">Sélectionner...</option>
                                                    <option value="bank_transfer">Virement Bancaire</option>
                                                    <option value="cash">Espèces</option>
                                                    <option value="check">Chèque</option>
                                                    <option value="mobile_money">Mobile Money</option>
                                                    <option value="other">Autre</option>
                                                </Input>
                                            </FormGroup>
                                        </Col>
                                        <Col lg="6">
                                            <FormGroup>
                                                <Label>Référence de Paiement <span className="text-danger">*</span></Label>
                                                <Input
                                                    type="text"
                                                    name="payment_reference"
                                                    placeholder="Ex: VIRT-2026-001"
                                                    value={formData.payment_reference}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col lg="12">
                                            <FormGroup>
                                                <Label>Notes (optionnel)</Label>
                                                <Input
                                                    type="textarea"
                                                    name="payment_notes"
                                                    rows="3"
                                                    placeholder="Notes internes..."
                                                    value={formData.payment_notes}
                                                    onChange={handleChange}
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>

                                    <div className="text-end">
                                        <Button color="secondary" className="me-2" onClick={toggle}>
                                            Annuler
                                        </Button>
                                        <Button color="success" type="submit" disabled={loading}>
                                            {loading ? (
                                                <>
                                                    <span className="spinner-border spinner-border-sm me-2"></span>
                                                    Activation...
                                                </>
                                            ) : (
                                                <>
                                                    <i className="mdi mdi-check me-1"></i>
                                                    Confirmer & Activer
                                                </>
                                            )}
                                        </Button>
                                    </div>
                                </Form>
                            </>
                        )}
                    </ModalBody>
                </Modal>
            </div>
        </React.Fragment>
    )
}

export default connect(null, { setBreadcrumbItems })(PendingSubscriptions)
